import { COLD_WEATHER_BATTERY_VERSION } from '~/devices/device-helpers';
import { LitEntity, html, renderIf } from '../../utility/lit-entity';
import '../../common/bn-loading';
import '../../common/bn-surface';
import '../../common/bn-property';

const BATTERY_DISPLAY_NAMES = {
  [COLD_WEATHER_BATTERY_VERSION]: 'Cold Weather Battery',
  '': 'N/A',
};

class DeviceBatteryDisplayName extends LitEntity {
  render() {
    const currentBatteryVersion = this.entity?.properties.batteryVersion || '';
    const batteryDisplayName = BATTERY_DISPLAY_NAMES[currentBatteryVersion];
    return html`
      <span>
        ${batteryDisplayName || 'Unknown Battery Version'} 
        ${renderIf(currentBatteryVersion, () => html`
          (${currentBatteryVersion})
        `)}
      </span>
    `;
  }
}

window.customElements.define('device-battery-display-name', DeviceBatteryDisplayName);
